import { RefreshCw } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import type { TradeIdeasFilterCatalogSeed } from "@/lib/tradeideas/types";

export function FilterCatalogActions({
  seed,
  pending,
  onRefresh,
}: {
  seed: TradeIdeasFilterCatalogSeed | undefined;
  pending: boolean;
  onRefresh: () => void;
}) {
  return (
    <section className="flex items-center justify-between gap-3 rounded-md border border-border bg-muted/20 px-3 py-2">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h2 className="text-sm font-semibold">Embedded Seed</h2>
          <Badge variant="outline">{seed?.source ?? "loading"}</Badge>
        </div>
        <p className="text-xs text-muted-fg">
          {seed ? `${seed.count} filters available in the bot binary.` : "Reading seed catalog."}
        </p>
      </div>
      <Button type="button" size="sm" variant="outline" disabled={pending} onClick={onRefresh}>
        <RefreshCw className="size-4" />
        Refresh
      </Button>
    </section>
  );
}
